import React from 'react';

// Turns bare email addresses inside a plain string into mailto: links.
//
// Copy that mentions an address (FAQ answers, notes) goes through this so the
// address is tappable and, just as importantly, always sits inside an <a>.
// The pre-render wraps every mailto link so Cloudflare's email obfuscation
// leaves it alone (see client/scripts/prerender.mjs); a bare address in a
// text node would be rewritten into a "[email protected]" link instead,
// which breaks React hydration on the live site.
const EMAIL_RE = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/i;

export function withEmailLinks(text, className) {
  if (typeof text !== 'string' || !EMAIL_RE.test(text)) return text;
  return text.split(EMAIL_RE).map((part, i) => (
    i % 2 === 1
      ? <a key={i} href={`mailto:${part}`} className={className}>{part}</a>
      : part
  ));
}
